export default __webpack_public_path__ + "static/img1_create_form-b51077f776589a46e8eaa5d1bee1af45.png";